import { useTranslation } from 'react-i18next';
import './LangSwitcher.css';

function LangSwitcher() {
    const { i18n } = useTranslation();
    const resolvedLanguage = i18n.resolvedLanguage;
  
    const switchLanguage = () => {
        if(resolvedLanguage === 'en') i18n.changeLanguage('ru');
        else i18n.changeLanguage('en');
    };

    return (
        <div
            className='LangSwitcher'
            onClick={() => switchLanguage()}
        >
            {resolvedLanguage}
        </div>
    );
}

export default LangSwitcher;
